import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { propTypes } from 'shared/proptypes/Company';
import { createStaticsLink } from 'shared/routes';
import { COMPANY_LOGO_POSITION } from 'shared/constants';
import CompanyHeader from './Header';
import styles from './WithImageHeader.module.scss';

const CompanyWithImageHeader = ({ company }) => {
  const { logoPosition, headerOnlyLogo, headerImageFullWidth, headerImageMinHeight } = company;

  if (!headerImageFullWidth) {
    return (
      <div className="container mb16">
        <div className="row">
          <div
            className={cn('col-12 relative', styles.content)}
            style={{ minHeight: headerImageMinHeight }}
          >
            <div
              className={cn(styles.imageInner, styles[logoPosition])}
              style={{ backgroundImage: `url(${createStaticsLink(company.headerImage)})` }}
            >
              {logoPosition !== COMPANY_LOGO_POSITION.UNDER && (
                <CompanyHeader
                  onlyLogo={headerOnlyLogo}
                  company={company}
                  className={cn(styles.header, logoPosition === COMPANY_LOGO_POSITION.HIDE ? styles.hidden : null)}
                />
              )}
            </div>
          </div>
        </div>
        {logoPosition === COMPANY_LOGO_POSITION.UNDER && (
          <div className={styles.underWrap}>
            <CompanyHeader
              alignInfoTop
              companySizeInline
              onlyLogo={headerOnlyLogo}
              company={company}
              className={cn(styles.header, styles.under, headerOnlyLogo ? 'mt8 mb8' : null)}
            />
          </div>
        )}
      </div>
    );
  }

  return (
    <>
      <div className={cn(styles.wrapper, logoPosition !== COMPANY_LOGO_POSITION.UNDER ? 'mb16' : null)}>
        <div
          className={styles.imageWide}
          style={{ backgroundImage: `url(${createStaticsLink(company.headerImage)})` }}
        />
        <div className="container">
          <div className="row">
            <div
              className={cn('col-12', styles.content, styles[logoPosition])}
              style={{ minHeight: headerImageMinHeight }}
            >
              {logoPosition !== COMPANY_LOGO_POSITION.UNDER && (
                <CompanyHeader
                  onlyLogo={headerOnlyLogo}
                  company={company}
                  className={cn(styles.header, logoPosition === COMPANY_LOGO_POSITION.HIDE ? styles.hidden : null)}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      {logoPosition === COMPANY_LOGO_POSITION.UNDER && (
        <div className="container mb16">
          <div className={styles.underWrap}>
            <CompanyHeader
              alignInfoTop
              companySizeInline
              onlyLogo={headerOnlyLogo}
              company={company}
              className={cn(styles.header, styles.under, headerOnlyLogo ? 'mt8 mb8' : null)}
            />
          </div>
        </div>
      )}
    </>
  );
};

CompanyWithImageHeader.propTypes = {
  company: PropTypes.shape({ ...propTypes, description: PropTypes.string }).isRequired
};

export default CompanyWithImageHeader;
